export default "__VITE_ASSET__B02Vaum6__"